import ColorUtility from './ColorUtility'
const colors = [
    ColorUtility.red1, ColorUtility.green1, ColorUtility.yellow1, ColorUtility.blue1, ColorUtility.teal1, ColorUtility.orange1, ColorUtility.purple1, 
    ColorUtility.red2, ColorUtility.green2, ColorUtility.yellow2, ColorUtility.blue2, ColorUtility.purple2,
    ColorUtility.red3, ColorUtility.green3, ColorUtility.yellow3, ColorUtility.blue3, ColorUtility.purple3,
    ColorUtility.blue4
];

export function getLegacyTagColor(tagId : number)
{
    let color = colors[tagId % colors.length];
    return { r: Math.round(255 * color.x), g: Math.round(255 * color.y), b: Math.round(255 * color.z) };
}